import React from 'react';
import { useTranslation } from 'react-i18next';

// The required-field marker. A word, not an asterisk: screen readers skip a bare
// "*".
// `size="sm"` is about 15% smaller, for dense panels such as the webhook
// builder's field labels.
const RequiredTag = ({ size = 'md' }: { size?: 'md' | 'sm' }) => {
  const { t } = useTranslation();
  const sizing =
    size === 'sm'
      ? 'ml-1.5 px-1 py-px text-[9.5px]'
      : 'ml-2 px-1.5 py-0.5 text-[11px]';

  return (
    // The leading space separates it in the label's accessible name, which is
    // the text run together ("Email Required", not "EmailRequired").
    <>
      {' '}
      <span
        className={`${sizing} rounded bg-greyscale-10 align-middle font-medium uppercase tracking-wide text-greyscale-5 transition-colors duration-300`}
      >
        {t('Required')}
      </span>
    </>
  );
};

export default RequiredTag;
